import { defineMessages } from 'react-intl';

export const collapsibleCardMessages = defineMessages({
  collapsibleCardExpendedAria: {
    id: 'collapsible.card.action.expended.aria.label',
    defaultMessage: 'Mehr Produkteigenschaften anzeigen',
  },
  collapsibleCardCollapsedAria: {
    id: 'collapsible.card.action.collapsed.aria.label',
    defaultMessage: 'Weniger Produkteigenschaften anzeigen',
  },
});
